// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconAuthorCard: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="656"
            height="120"
            viewBox="0 0 656 120"
        >
            <defs>
                <pattern id="b" width="100%" height="100%" x="0%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(2.5)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g transform="translate(144 12)">
                    <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                        <tspan x="0" y="92">
                            {"{Job Title / Company}"}
                        </tspan>
                    </text>
                    <line x1=".5" x2="511.5" y1="65.5" y2="65.5" stroke="#979797" strokeLinecap="square" />
                    <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="24">
                        <tspan x="0" y="47">
                            {"{Firstname} {Lastname}"}
                        </tspan>
                    </text>
                    <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                        <tspan x="0" y="14">
                            Article By:
                        </tspan>
                    </text>
                </g>
                <rect width="119" height="119" x=".5" y=".5" fill="url(#b)" stroke="#B0AEAE" rx="59.5" />
            </g>
        </svg>
    );
};

export default React.memo(IconAuthorCard);
